import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { imgUrl } from "@/lib/api";
import { EASE } from "./Reveal";
import { SelectButton } from "./SelectButton";
import { CompareButton } from "./Compare";
import { isComparable } from "@/context/CompareContext";
import { FinishDots } from "./FinishDots";

export const ItemCard = ({ item, i = 0, compact = false }) => (
  <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease: EASE, delay: (i % 3) * 0.08 }} className="relative min-w-0">
    <div className={`absolute z-10 flex flex-col gap-2 ${compact ? "top-1.5 right-1.5 scale-90 origin-top-right sm:top-3 sm:right-3 sm:scale-100" : "top-3 right-3"}`}><SelectButton item={item} />{isComparable(item) && <CompareButton item={item} />}</div>
    <Link to={`/item/${item.id}`} data-testid={`item-card-${item.id}`} className="group block">
      <div className={`relative ${compact ? "aspect-square sm:aspect-[4/5]" : "aspect-[4/5]"} overflow-hidden border border-[#D4AF37]/20 bg-[#13141C]`}>
        {item.images?.[0] ? (
          <img src={imgUrl(item.images[0])} alt={item.name} loading="lazy"
            className="w-full h-full object-cover group-hover:scale-[1.06] transition-transform duration-[1200ms] ease-out" />
        ) : (
          <div className="w-full h-full grid place-items-center font-mono-j text-xs text-[#A09E97]">NO IMAGE</div>
        )}
        <div className="absolute inset-0 shadow-[inset_0_0_80px_rgba(13,13,17,0.6)]" />
        {item.code && (
          <span className={`absolute top-4 left-4 font-mono-j text-[11px] uppercase tracking-[0.2em] text-[#E5C158] bg-[#0D0D11]/70 backdrop-blur px-2.5 py-1 ${compact ? "hidden sm:inline" : ""}`}>
            {item.code}
          </span>
        )}
      </div>
      <div className={`${compact ? "mt-3 sm:mt-5" : "mt-5"} flex items-start justify-between gap-4`}>
        <div className="min-w-0">
          <h3 className={`font-display ${compact ? "text-lg leading-tight sm:text-2xl" : "text-2xl"} text-[#F5F3EF] group-hover:text-[#E5C158] transition-colors duration-300 break-words`}>{item.name}</h3>
          {item.supplier && <p className={`mt-1 ${compact ? "text-xs sm:text-sm" : "text-sm"} text-[#A09E97]`}>{item.supplier}</p>}
          <FinishDots item={item} />
        </div>
        <span className={`mt-2 h-px w-8 bg-[#D4AF37]/50 group-hover:w-14 transition-[width] duration-500 ${compact ? "hidden sm:block" : ""}`} />
      </div>
    </Link>
  </motion.div>
);
